import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { HTMLContent } from '../components/Content'
import { AboutPageTemplate } from './about-page'

export const SPAAboutPage = () => {
  const { aboutPages } = useStaticQuery(
    graphql`
        query About {
          aboutPages: allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "about-page"}}}) {
            edges {
                node {
                fields {
                    slug
                }
                id
                html
                frontmatter {
                  title
                  image {
                  childImageSharp {
                    fluid(maxWidth: 1024, quality: 100) {
                      ...GatsbyImageSharpFluid
                    }
                    }
                  }
                }
                }
            }
        }
    }
    `);
  const about = aboutPages.edges[0].node;
  return (
    <AboutPageTemplate
    image={about.frontmatter.image}
    contentComponent={HTMLContent}
    title={about.frontmatter.title}
    content={about.html}
  />
  )
}
